import { render, staticRenderFns } from "./404PagesPage.vue?vue&type=template&id=676cd8f6"
import script from "./404PagesPage.vue?vue&type=script&lang=js"
export * from "./404PagesPage.vue?vue&type=script&lang=js"
import style0 from "./404PagesPage.vue?vue&type=style&index=0&id=676cd8f6&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('676cd8f6')) {
      api.createRecord('676cd8f6', component.options)
    } else {
      api.reload('676cd8f6', component.options)
    }
    module.hot.accept("./404PagesPage.vue?vue&type=template&id=676cd8f6", function () {
      api.rerender('676cd8f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/404-pages/404PagesPage.vue"
export default component.exports